import React from "react";
import { AssessmentTabsProvider } from "./AssessmentTabsProvider";
import { AssessmentProvider } from "./AssessmentProvider";
import { GuidedModeProvider } from "./GuidedModeProvider";
import { AssessmentSaveAndExitProvider } from "./AssessmentSaveAndExitProvider";
import { PatientProvider } from "./PatientProvider";
import { PatientAndAssessmentDataHelperProvider } from "./PatientAndAssessmentDataHelperProvider";
import { AssessmentWalkthroughProvider } from "./AssessmentWalkthroughProvider";
import { ShowErrorDiaglogProvider } from "./ShowErrorDiaglogProvider";

const CombinedProvider = ({ children }) => {
  return (
    <GuidedModeProvider>
      <AssessmentTabsProvider>
        <AssessmentSaveAndExitProvider>
          <AssessmentWalkthroughProvider>
            <PatientProvider>
              <AssessmentProvider>
                <PatientAndAssessmentDataHelperProvider>
                  <ShowErrorDiaglogProvider>
                    {children}
                  </ShowErrorDiaglogProvider>
                </PatientAndAssessmentDataHelperProvider>
              </AssessmentProvider>
            </PatientProvider>
          </AssessmentWalkthroughProvider>
        </AssessmentSaveAndExitProvider>
      </AssessmentTabsProvider>
    </GuidedModeProvider>
  );
};

export default CombinedProvider;
